<script>
import Hotkey from 'dashboard/components/base/Hotkey.vue';
// custom (redesign Modeloja): o modificador seguia fixo em ⌘, então a operação inteira —
// que roda em Windows — via um atalho que não existe no teclado dela. `isApple()` já
// existia em shared/helpers/platform.js; aqui era só perguntar.
import { isApple } from 'shared/helpers/platform';

export default {
  components: {
    Hotkey,
  },
  data() {
    return {
      // Ctrl no Windows/Linux é o modificador de verdade do CommandBar (ele escuta
      // metaKey || ctrlKey), então mostrar "Ctrl" não é aproximação: é o que funciona.
      modifierKey: isApple() ? '⌘' : 'Ctrl',
      keyShortcuts: [
        {
          key: 'K',
          description: this.$t('CONVERSATION.EMPTY_STATE.CMD_BAR'),
        },
        {
          key: '/',
          description: this.$t('CONVERSATION.EMPTY_STATE.KEYBOARD_SHORTCUTS'),
        },
      ],
    };
  },
};
</script>

<template>
  <div class="flex flex-col gap-2 mt-9">
    <div
      v-for="keyShortcut in keyShortcuts"
      :key="keyShortcut.key"
      class="flex items-center gap-2"
    >
      <div class="flex items-center gap-2">
        <!-- "Ctrl" não cabe nos 32px que o ⌘ ocupava: largura mínima em vez de fixa, e o
             corpo do texto acompanha o modificador em vez de ficar em text-lg de símbolo. -->
        <Hotkey
          custom-class="min-w-8 h-6 px-1.5 text-xs font-medium text-n-slate-12 outline outline-n-container outline-1 bg-n-alpha-3"
        >
          {{ modifierKey }}
        </Hotkey>
        <Hotkey
          custom-class="w-8 h-6 text-xs font-medium text-n-slate-12 outline outline-n-container outline-1 bg-n-alpha-3"
        >
          {{ keyShortcut.key }}
        </Hotkey>
      </div>
      <span class="text-sm font-medium text-center text-n-slate-11">
        {{ keyShortcut.description }}
      </span>
    </div>
  </div>
</template>
